<template>
  <el-dialog
    title="商品配置"
    :visible.sync="visible"
    width="900px"
    append-to-body
    @closed="handleClosed"
  >
    <div class="product-transfer-wrap">
      <el-transfer
        v-model="ruleForm.multipleSelection"
        filterable
        :filter-method="filterMethod"
        filter-placeholder="请输入商品名称"
        :titles="['未应用', '已应用']"
        :data="ruleForm.list"
        :props="{
          key: 'productId',
          label: 'productName',
        }"
      ></el-transfer>
    </div>
    <div slot="footer">
      <el-button
        type="primary"
        @click="addItem">更新</el-button>
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'product-set-modal',
  components: {},
  props: {
    callback: Function
  },
  data () {
    return {
      loading: false,
      ruleForm: {
        list: [],
        multipleSelection: []
      },
      visible: false,
      staffInfo: {}
    }
  },
  methods: {
    filterMethod (query, item) {
      return item.productName.indexOf(query) > -1
    },
    toggleModal (visible) {
      this.visible = visible
    },
    handleClosed () {
      this.ruleForm = {
        list: [],
        multipleSelection: []
      }
      this.staffInfo = {}
    },
    fetchList (cb) {
      this.loading = true
      this.$store.dispatch('product/getproducts', {
        payload: {
          pageNum: 1,
          status: 2,
          pageSize: 100000
        },
        success: (res) => {
          this.loading = false
          this.ruleForm.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch (row) {
      this.staffInfo = row
      this.loading = true
      this.$store.dispatch('staff/getstaffproducts', {
        payload: {
          pageSize: 1000,
          pageNum: 1,
          staffId: row.staffId,
          productId: null
        },
        success: (res) => {
          this.loading = false
          this.ruleForm.multipleSelection = res.data.records.map(i => i.productId)
          this.fetchList(() => {
            this.toggleModal(true)
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    addItem () {
      const result = this.ruleForm.multipleSelection
      // if (result.length === 0) {
      //   this.$message.error('请选择商品')
      //   return
      // }
      this.loading = true
      this.$store.dispatch('staff/setstaffproducts', {
        payload: {
          staffId: this.staffInfo.staffId,
          productIds: result,
          oper: 'update'
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.callback && this.callback()
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.product-transfer-wrap {
  .el-transfer {
    height: 400px;

    .el-transfer-panel {
      width: 300px;
      height: 100%;

      .el-transfer-panel__body {
        height: calc(100% - 40px);

        .el-transfer-panel__list {
          height: calc(100% - 62px);
        }
      }
    }
  }
}
</style>
